import { render, staticRenderFns } from "./notificationTr.vue?vue&type=template&id=973c30be&scoped=true"
import script from "./notificationTr.vue?vue&type=script&lang=js"
export * from "./notificationTr.vue?vue&type=script&lang=js"
import style0 from "./notificationTr.vue?vue&type=style&index=0&id=973c30be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973c30be",
  null
  
)

export default component.exports